import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import EnvironmentsOverview from "./EnvironmentsOverview"

const Environments = () => {
  return (
    <SidePanelLayout
      menuName="AdminSiteEnvironments"
      tabs={{
        environments: EnvironmentsOverview,
      }}
    />
  )
}

export default Environments
